import React from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useLocalStorage } from "../hooks/useLocalStorage";

export const CollapsibleSection = ({
	storageKey,
	title,
	icon: Icon,
	iconColor,
	children,
	headerActions,
	defaultCollapsed = false,
}) => {
	const [isCollapsed, setIsCollapsed] = useLocalStorage(
		storageKey,
		defaultCollapsed,
	);

	return (
		<div className="border border-[var(--color-border)] rounded-lg p-4 mb-6 bg-transparent">
			<div className="flex items-center justify-between mb-4">
				<button
					onClick={() => setIsCollapsed(!isCollapsed)}
					className="text-base font-semibold flex items-center gap-2 text-[var(--color-text-primary)] hover:text-[var(--color-text-secondary)] cursor-pointer"
				>
					{isCollapsed ? (
						<ChevronRight className="w-4 h-4 text-[var(--color-text-secondary)]" />
					) : (
						<ChevronDown className="w-4 h-4 text-[var(--color-text-secondary)]" />
					)}
					{Icon && <Icon className={`w-4 h-4 ${iconColor}`} />}
					{title}
				</button>

				{!isCollapsed && headerActions}
			</div>

			{!isCollapsed && children}
		</div>
	);
};

export default CollapsibleSection;
